import Result from "@/core/common/Result";
import { IIniciarVoucherGateway } from "../ports/IniciarVoucherGateway";
import { inject, injectable } from "inversify";
import { DITypes } from "@/core/@types/types";
import { type HttpClient } from "@/core/services/protocols/types";
import { IDefaultContabilResponse } from "@/services/contabil/types";
import "reflect-metadata";

@injectable()
export class IniciarVoucherGatewayAdapter implements IIniciarVoucherGateway {
  @inject(DITypes.CONTABIL_HTTP_CLIENT)
  client!: HttpClient;

  async sendDataVisualizacao(
    id: string,
    dataVisualizacao: string
  ): Promise<Result<void>> {
    try {
      const response = await this.client.post<IDefaultContabilResponse<void>>({
        url: `/v1/contabil/voucher/${id}/visualizar`,
        body: {
          dataVisualizacao
        }
      });

      if (response.body?.code !== 200 || response.statusCode !== 200)
        return Result.fail("Não foi possível inciar o voucher");

      return Result.ok();
    } catch (e) {
      return Result.fail("Erro ao iniciar o voucher");
    }
  }
}
